import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

// Utility functions
const saveToStorage = (key, value) => localStorage.setItem(key, JSON.stringify(value));
const getFromStorage = (key, fallback) => {
  const data = localStorage.getItem(key);
  return data ? JSON.parse(data) : fallback;
};

export default function AdminPanel() {
  const [tab, setTab] = useState("home");

  // =================== Home Page Data ===================
  const [carouselHeading, setCarouselHeading] = useState(getFromStorage("carouselHeading", "Innovative Solutions"));
  const [carouselText, setCarouselText] = useState(getFromStorage("carouselText", "Empowering your business with scalable tech solutions."));
  const [aboutPreviewText, setAboutPreviewText] = useState(getFromStorage("aboutPreviewText", "At Vizionexl, we are a technology-driven company..."));
  const [bookCallText, setBookCallText] = useState(getFromStorage("bookCallText", "Discuss your ideas or challenges with our experts."));

  // =================== About Page Data ===================
  const [about1, setAbout1] = useState(getFromStorage("about1", "Driving Innovation with Technology..."));
  const [about2, setAbout2] = useState(getFromStorage("about2", "A Team Built for the Future..."));
  const [about3, setAbout3] = useState(getFromStorage("about3", "Empowering All Businesses..."));

  // =================== Careers Page ===================
  const [careerHeading, setCareerHeading] = useState(getFromStorage("careerHeading", "Define your career with Vizionexl"));
  const [jobList, setJobList] = useState(getFromStorage("jobList", [
    { title: "Frontend Developer", location: "Bijapur" },
  ]));

  // =================== Projects Page ===================
  const [projects, setProjects] = useState(getFromStorage("projects", [
    { title: "Restaurant Management", desc: "Digital solution for restaurants." },
    { title: "Jewelry Shop System", desc: "Inventory and sales system." },
  ]));

  // =================== What We Do ===================
  const [expertise, setExpertise] = useState(getFromStorage("expertise", [
    { id: "software-dev", title: "Custom Software", content: "We build tailored software for web, mobile..." }
  ]));

  // =================== Consult Page ===================
  const [consultText, setConsultText] = useState(getFromStorage("consultText", "Looking to collaborate? Reach out to us for customized solutions."));
  const [mapURL, setMapURL] = useState(getFromStorage("mapURL", "https://maps.google.com/..."));

  // =================== Save All Data ===================
  const handleSave = () => {
    saveToStorage("carouselHeading", carouselHeading);
    saveToStorage("carouselText", carouselText);
    saveToStorage("aboutPreviewText", aboutPreviewText);
    saveToStorage("bookCallText", bookCallText);
    saveToStorage("about1", about1);
    saveToStorage("about2", about2);
    saveToStorage("about3", about3);
    saveToStorage("careerHeading", careerHeading);
    saveToStorage("jobList", jobList);
    saveToStorage("projects", projects);
    saveToStorage("expertise", expertise);
    saveToStorage("consultText", consultText);
    saveToStorage("mapURL", mapURL);
    alert("✅ Changes saved ");
  };

  // =================== UI Per Tab ===================
  const renderTab = () => {
    switch (tab) {
      case "home":
        return (
          <>
            <h4>Home Page</h4>
            <label>Carousel Heading</label>
            <input className="form-control mb-2" value={carouselHeading} onChange={(e) => setCarouselHeading(e.target.value)} />
            <label>Carousel Text</label>
            <input className="form-control mb-2" value={carouselText} onChange={(e) => setCarouselText(e.target.value)} />
            <label>About Preview</label>
            <textarea className="form-control mb-2" rows={3} value={aboutPreviewText} onChange={(e) => setAboutPreviewText(e.target.value)} />
            <label>Book Call Text</label>
            <textarea className="form-control mb-2" rows={3} value={bookCallText} onChange={(e) => setBookCallText(e.target.value)} />
          </>
        );

      case "about":
        return (
          <>
            <h4>About Page</h4>
            <label>Section 1</label>
            <textarea className="form-control mb-2" rows={3} value={about1} onChange={(e) => setAbout1(e.target.value)} />
            <label>Section 2</label>
            <textarea className="form-control mb-2" rows={3} value={about2} onChange={(e) => setAbout2(e.target.value)} />
            <label>Section 3</label>
            <textarea className="form-control mb-2" rows={3} value={about3} onChange={(e) => setAbout3(e.target.value)} />
          </>
        );

      case "careers":
        return (
          <>
            <h4>Careers Page</h4>
            <label>Heading</label>
            <input className="form-control mb-3" value={careerHeading} onChange={(e) => setCareerHeading(e.target.value)} />
            <h6>Job Listings</h6>
            {jobList.map((job, i) => (
              <div key={i} className="d-flex gap-2 mb-2">
                <input className="form-control" placeholder="Title" value={job.title} onChange={(e) => {
                  const updated = [...jobList];
                  updated[i].title = e.target.value;
                  setJobList(updated);
                }} />
                <input className="form-control" placeholder="Location" value={job.location} onChange={(e) => {
                  const updated = [...jobList];
                  updated[i].location = e.target.value;
                  setJobList(updated);
                }} />
              </div>
            ))}
            <button className="btn btn-outline-secondary btn-sm" onClick={() => setJobList([...jobList, { title: "", location: "" }])}>+ Add Job</button>
          </>
        );

      case "projects":
        return (
          <>
            <h4>Projects Page</h4>
            {projects.map((proj, i) => (
              <div key={i} className="mb-2">
                <input className="form-control mb-1" placeholder="Project Title" value={proj.title} onChange={(e) => {
                  const updated = [...projects];
                  updated[i].title = e.target.value;
                  setProjects(updated);
                }} />
                <textarea className="form-control" placeholder="Description" value={proj.desc} onChange={(e) => {
                  const updated = [...projects];
                  updated[i].desc = e.target.value;
                  setProjects(updated);
                }} />
              </div>
            ))}
            <button className="btn btn-outline-secondary btn-sm" onClick={() => setProjects([...projects, { title: "", desc: "" }])}>+ Add Project</button>
          </>
        );

      case "whatwedo":
        return (
          <>
            <h4>What We Do</h4>
            {expertise.map((ex, i) => (
              <div key={i} className="mb-2">
                <input className="form-control mb-1" placeholder="ID" value={ex.id} onChange={(e) => {
                  const updated = [...expertise];
                  updated[i].id = e.target.value;
                  setExpertise(updated);
                }} />
                <input className="form-control mb-1" placeholder="Title" value={ex.title} onChange={(e) => {
                  const updated = [...expertise];
                  updated[i].title = e.target.value;
                  setExpertise(updated);
                }} />
                <textarea className="form-control" placeholder="Content" value={ex.content} onChange={(e) => {
                  const updated = [...expertise];
                  updated[i].content = e.target.value;
                  setExpertise(updated);
                }} />
              </div>
            ))}
            <button className="btn btn-outline-secondary btn-sm" onClick={() => setExpertise([...expertise, { id: "", title: "", content: "" }])}>+ Add Expertise</button>
          </>
        );

      case "consult":
        return (
          <>
            <h4>Consult Page</h4>
            <label>Top Message</label>
            <textarea className="form-control mb-2" rows={3} value={consultText} onChange={(e) => setConsultText(e.target.value)} />
            <label>Google Map Embed URL</label>
            <input className="form-control mb-2" value={mapURL} onChange={(e) => setMapURL(e.target.value)} />
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div className="container my-5">
      <h2 className="text-center mb-4">Admin Panel</h2>

      {/* Navigation Tabs */}
      <ul className="nav nav-pills mb-4 justify-content-center">
        {["home", "about", "careers", "projects", "whatwedo", "consult"].map((t) => (
          <li className="nav-item" key={t}>
            <button className={`nav-link ${tab === t ? "active" : ""}`} onClick={() => setTab(t)}>
              {t.charAt(0).toUpperCase() + t.slice(1)}
            </button>
          </li>
        ))}
      </ul>

      {/* Active Tab Content */}
      <div className="card p-4 shadow-sm">
        {renderTab()}
        <button className="btn btn-success mt-4" onClick={handleSave}>💾 Save Changes</button>
      </div>
    </div>
  );
}
